import React, { useEffect, useState } from 'react'
import ApexCharts from 'apexcharts'
import { ButtonMenu } from '@winnin/winnin_ui.components.button-menu'

import { useTranslate } from 'lib/tolgee'

import CustomChartLegendItem from './CustomChartLegendItem'

import './index.scss'

const TOLGEE_PREFFIX = 'CustomChartLegend'

/**
 * @param {Object} props
 * @param {string[]} props.legends
 * @param {number} [props.limit]
 * @param {boolean} [props.disableClick]
 * @param {string} props.chartId
 */
export default function CustomChartLegend({ legends = [], limit = 5, disableClick, chartId }) {
  const t = useTranslate()

  const [chart, setChart] = useState(null)
  const [, setRerender] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      const element = ApexCharts.getChartByID(chartId)
      if (element) {
        setChart(element)
      }
    }, 0)
  }, [chartId])

  useEffect(() => {
    rerender()
  }, [legends])

  function rerender() {
    setRerender(prev => !prev)
  }

  const handleLegendClick = legend => {
    try {
      if (disableClick) return

      chart?.toggleSeries?.(legend)
      rerender()
    } catch (ignoreError) {
      // ignore
    }
  }

  const checkInactiveLegend = legend => {
    try {
      const isInactive = chart?.series?.isSeriesHidden(legend)?.isHidden
      return isInactive
    } catch (ignoreError) {
      return false
    }
  }

  const getMarkerColorByLegend = legend => {
    const targetElement = chart?.series?.getSeriesByName(legend)
    const realIndex = parseInt(targetElement?.getAttribute('data:realIndex'), 10)
    const validIndex = !Number.isNaN(realIndex) ? realIndex : legends.indexOf(legend)

    return chart?.w?.config?.colors?.[validIndex]
  }

  const getMarkerSize = () => {
    return {
      width: parseInt(chart?.w?.config?.legend?.markers?.width) || 10,
      height: parseInt(chart?.w?.config?.legend?.markers?.width) || 10,
    }
  }

  const slicedLegends = legends.slice(0, !limit ? undefined : limit)
  const restLegends = limit ? legends.slice(limit) : []

  const markerSize = getMarkerSize()

  const options = restLegends.map(legend => ({
    label: (
      <CustomChartLegendItem
        legend={legend}
        inactive={checkInactiveLegend(legend)}
        markerColor={getMarkerColorByLegend(legend)}
        markerWidth={markerSize?.width}
        markerHeight={markerSize?.height}
      />
    ),
    onClick: () => handleLegendClick(legend),
  }))

  return (
    <div
      className="CustomChartLegend"
      style={{
        justifyContent: chart?.w?.config?.legend?.horizontalAlign,
      }}
    >
      <div
        className="CustomChartLegend-list"
        style={{
          justifyContent: chart?.w?.config?.legend?.horizontalAlign,
        }}
      >
        {slicedLegends.map(legend => (
          <CustomChartLegendItem
            key={legend}
            legend={legend}
            inactive={checkInactiveLegend(legend)}
            markerColor={getMarkerColorByLegend(legend)}
            markerWidth={markerSize?.width}
            markerHeight={markerSize?.height}
            onClick={() => handleLegendClick(legend)}
          />
        ))}
        {restLegends.length > 0 && (
          <ButtonMenu options={options} className="CustomChartLegend-menu">
            <p className="CustomChartLegend-more-text">
              {t({
                key: `${TOLGEE_PREFFIX}.moreLegends`,
                parameters: { count: restLegends.length },
                defaultValue: `{count} more`,
              })}
            </p>
          </ButtonMenu>
        )}
      </div>
    </div>
  )
}
